import { useEffect } from 'react';
import { getDevices } from '../lib/device';

type DeviceChangeCallbackFn = (devices: MediaDeviceInfo[]) => void;

function useDeviceChange(callbackFn: DeviceChangeCallbackFn, dependencies: Array<any>) {
    const handleDeviceChange = async () => {
        const newDevices = await getDevices();
        callbackFn(newDevices);
    };

    useEffect(() => {
        if (navigator.mediaDevices?.addEventListener) {
            navigator.mediaDevices.addEventListener('devicechange', handleDeviceChange);
        } else if (navigator.mediaDevices?.ondevicechange) {
            navigator.mediaDevices.ondevicechange = handleDeviceChange;
        }
        return () => {
            if (navigator.mediaDevices?.removeEventListener) {
                navigator.mediaDevices.removeEventListener('devicechange', handleDeviceChange);
            } else if (navigator.mediaDevices?.ondevicechange) {
                navigator.mediaDevices.ondevicechange = null;
            }
        };
    }, dependencies);
}

export default useDeviceChange;
